import React, { useState } from "react";
import "./app.css";
import { getImage } from "../../../../../utils/getImages";
const PreviewBestPrice = ({ cardData, activetab }) => {
  const [active, setActive] = useState(0);
  return (
    <div style={{ marginLeft: "10px" }}>
      <h3
        className="title-color mb-4"
        style={{
          marginLeft: "10px",
          alignItems: "center",
          width: "100%",
          textAlign: "center",
        }}
      >
        <p
          style={{ alignItems: "center", width: "100%", textAlign: "center" }}
          dangerouslySetInnerHTML={{
            __html: (activetab === "english"
              ? cardData?.title
              : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_title
                : activetab === "bahasa"
                  ? cardData?.bahasa_title
                  : cardData?.traditional_chinese_title)
          }}
        />
      </h3>
      <p
        style={{ alignItems: "center", width: "100%", textAlign: "center" }}
        dangerouslySetInnerHTML={{
          __html:
            activetab === "english"
              ? cardData?.description
              : activetab === "simplified_chinese"
              ? cardData?.simplified_chinese_description
              : activetab === "arabic"
              ? cardData?.arabic_description
              : activetab === "bahasa"
              ? cardData?.bahasa_description
              : cardData?.traditional_chinese_description,
        }}
      />
      <div
        style={{
          display: "flex",
          // alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        <div className="row" style={{ width: "100%" }}>
          <div
            style={{
              width: "100%",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <div
              className="faq2-holder border position-relative overflow-hidden rounded-top"
              style={{ borderRadius: "10px", overflow: "hidden", margin: 20 }}
            >
              <div className="faq2s">
                {cardData?.dataArray?.map((item, index) => (
                  <div
                    onClick={(item) => {
                      setActive(index);
                    }}
                  >
                    <p
                      style={{
                        background: "white",
                        padding: "20px 30px",
                        color: "#727272",
                        borderBottom: "1px solid lightgray",
                      }}
                    >
                      {activetab === "english"
                        ? item?.title
                        : activetab === "simplified_chinese"
                        ? item?.simplified_chinese_title
                        : activetab === "bahasa"
                        ? item?.bahasa_title
                        : item?.traditional_chinese_title}
                    </p>
                    <div>
                      <p
                        style={{
                          display: active === index ? "block" : "none",
                          direction: activetab === "arabic" && "rtl",
                          padding: "20px 30px",
                          background:"#ECECEC"
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            activetab === "english"
                              ? item?.answer
                              : activetab === "simplified_chinese"
                              ? item?.simplified_chinese_answer
                              : activetab === "arabic"
                              ? item?.arabic_answer
                              : activetab === "bahasa"
                              ? item?.bahasa_answer
                              : item?.traditional_chinese_answer,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewBestPrice;
